import isNil from 'lodash/isNil';

/**
 * Duplicates the hasura playbook response and attaches deployed playbook revisions from
 * the control API response.
 *
 * NEW PROPERTY
 * playbooks[].staged_revisions[].pipeline_integration.deployed_revision
 *
 * @param {Object} params
 * @param {Object} params.ionIntegrationResponse - Integration playbooks from Hasura API
 * @param {Object} params.controlIntegrationResponse - Integrations from Control API
 * @return {Object|null}
 */
function mergePlaybookRevisions({ ionIntegrationResponse, controlIntegrationResponse }) {
  if (isNil(ionIntegrationResponse)) {
    return null;
  }

  // use the hasura response as the base
  const mergedIonIntegrationResponse = {
    ...ionIntegrationResponse,
  };

  // shouldn't happen, hasura API returns empty array if there are no playbooks
  if (!Array.isArray(mergedIonIntegrationResponse.playbooks)) {
    return mergedIonIntegrationResponse;
  }

  // alter playbooks.staged_revisions
  mergedIonIntegrationResponse.playbooks = ionIntegrationResponse.playbooks.map(playbook => {
    const mergedPlaybook = {
      ...playbook,
    };

    // add pipeline_integration.deployed_revision to each staged_revision
    mergedPlaybook.staged_revisions = playbook.staged_revisions.map(stagedRevision => {
      const mergedStagedRevision = {
        ...stagedRevision,
        pipeline_integration: {
          ...stagedRevision.pipeline_integration,
          // control api data placeholder
          deployed_revision: null,
        },
      };

      // extract keys from hasura data to use for matching
      const clusterId = stagedRevision.pipeline_integration.pipeline.cluster.id;
      const integrationId = mergedIonIntegrationResponse.id;
      const stagedRevisionId = stagedRevision.id;
      const pipelineWriteKey = stagedRevision.pipeline_integration.pipeline.writekey;

      if (isNil(controlIntegrationResponse) || isNil(controlIntegrationResponse[clusterId])) {
        return mergedStagedRevision;
      }

      // flatten the control api integration revisions details
      // from response[clusterId].integrations[].details[]
      const controlIntegrations = Array.isArray(controlIntegrationResponse[clusterId].integrations)
        ? controlIntegrationResponse[clusterId].integrations
        : [];

      const flatControlRevisions = controlIntegrations.flatMap(integration =>
        Array.isArray(integration.details) ? integration.details : []
      );

      // find matching control revision
      // if deployed ONLY via control cli, then no matches will be found
      const foundControlRevision = flatControlRevisions.find(
        controlRevision =>
          controlRevision.integrationId === integrationId &&
          controlRevision.pipelineRevisionId === stagedRevisionId &&
          controlRevision.writeKey === pipelineWriteKey
      );

      // hasura API has int revision #, control API is str, keep all as int
      if (!isNil(foundControlRevision?.playbookVersion)) {
        mergedStagedRevision.pipeline_integration.disabled = foundControlRevision.disabled;
        mergedStagedRevision.pipeline_integration.deployed_revision = parseInt(foundControlRevision.playbookVersion);
      }

      return mergedStagedRevision;
    });
    // end add pipeline_integration.deployed_revision

    return mergedPlaybook;
  });
  // end alter playbooks.staged_revisions

  return mergedIonIntegrationResponse;
}

export default mergePlaybookRevisions;
